import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import './EmployeesData.css';
import { selectStyles } from '../../../../assets/Styles/selectStyle';
import { getDistrict, getProjects, getStates, getClients, getProject, fetchMonths, getFinalAttendanceReport } from '../../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../../utils/validations';
import { Link } from 'react-router-dom';
import { fetchEmployeeDetails, fetchEmployeeFromSelf } from '../../../../services/resgisterEmployeesList';
import { getDesignationsPriority } from "../../../../services/employeeCreationService";
import ExcelJS from 'exceljs';
const EmployeesData = () => {
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(0);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);
    const [clientResponse, setClientResponse] = useState([]);
    const [clients, setClients] = useState(null);
    const effectRan = useRef(false);
    const [employeeData, setEmployeeData] = useState([]); // ✅ new state for table data
    const [selectedDesignation, setSelectedDesignation] = useState(null);
    const [designations, setDesignations] = useState([]);
    const [isFocused, setIsFocused] = useState({
        state: false,
        // district: false,
        month: false,
        year: false,
        project: false,
        clients: false,
    });
    const [errors, setErrors] = useState({});
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const isFetchDataEnabled = state && month && year && project;
    // Get user info from localStorage (or API)

    const roleId = localStorage.getItem('roleId');
    const employeeId = localStorage.getItem('employeeId');

    const generateExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Employees Details");

        // Title
        worksheet.mergeCells("A1:G1");
        const titleCell = worksheet.getCell("A1");
        titleCell.value = "Employees Details";
        titleCell.font = { size: 16, bold: true };
        titleCell.alignment = { vertical: "middle", horizontal: "center" };

        // Headers
        const headers = [
            "S.No",
            "Employee Name",
            "Designation",
            "Working District",
            "Date of Joining",
            "Graduation ( specialization )",
            "Post Graduation ( specialization )",
        ];

        worksheet.addRow(headers);

        // Style header
        const headerRow = worksheet.lastRow;
        headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
        headerRow.alignment = { horizontal: "center" };
        headerRow.eachCell((cell) => {
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4472C4" } };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
        });


        // Adjust Column Widths
        worksheet.columns = [
            { width: 10 },  // S.No
            { width: 20 },  // District Name
            { width: 25 },  // Employee Name
            { width: 25 },  // Designation
            { width: 35 },  // Email
            { width: 45 },  // Contact Number
            { width: 45 },  // Contact Number
        ];

        // ✅ Use the same data as your UI
        if (!employeeData || employeeData.length === 0) {
            worksheet.addRow(["No employee data available"]);
        } else {
            employeeData.forEach((row, index) => {
                const newRow = worksheet.addRow([
                    index + 1,
                    row.fullName || "",
                    row.designation || "",
                    row.workingDistrict || "",
                    row.dateOfJoining
                        ? new Date(row.dateOfJoining)
                            .toLocaleDateString("en-GB")
                            .replace(/\//g, "-")
                        : ""
                    ,
                    row.graduation === "N/A" || !row.graduation ? "-" : row.graduation,
                    row.postGraduation === "N/A" || !row.postGraduation ? "-" : row.postGraduation,

                ]);

                // Center align S.No column (first cell of every row)
                newRow.getCell(1).alignment = { horizontal: "center" };
            });

        }



        // Download Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Employees_Details.xlsx`;
        link.click();
    };

    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);



    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const data = await getDistrict(state);

                    const filterData = [
                        { value: 0, label: "All Districts" },
                        ...data
                            //.filter(item => item.districtId === 39)
                            .map(item => ({
                                value: item.districtId,
                                label: item.districtName
                            }))
                    ];

                    setDistrictOptions(filterData);
                    // ✅ Set district to the default 'All Districts' option when state loads
                    // setDistrict(0);

                } catch (err) {
                    console.error('Error fetching districts:', err);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null); // Clear district if state is cleared
        }
    }, [state]);
    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonths(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);


    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchClients = async () => {
                try {
                    // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects`);
                    const data = await getClients(state);
                    setClientResponse(data.map(client => ({
                        value: client.id,
                        label: client.clientName,
                    }))
                    );
                } catch (error) {
                    console.error('Error fetching states:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
                }
            };
            fetchClients();
        }
        else {
            setClients(null);
        }
    }, [state]);


    useEffect(() => {
        if (clients) {
            const fetchProjects = async () => {
                try {
                    const data = await getProject(clients);
                    setProjectResponse(data.map(pro => ({
                        value: pro.id,
                        label: pro.projectCode,
                    })));
                } catch (error) {
                    console.error('Error fetching projects:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
                }
            };

            fetchProjects();
        } else {
            setProjectResponse([]); // Reset projects if no client is selected
        }
    }, [clients]);


    // Fetch designations
    useEffect(() => {
        const fetchDesignation = async () => {
            try {
                const data = await getDesignationsPriority();
                if (Array.isArray(data)) {

                    const sortedData = data
                        .sort((a, b) => a.designationName.localeCompare(b.designationName))
                        .map((d) => ({
                            value: d.id,
                            label: d.designationName,
                        }));

                    setDesignations(sortedData);
                } else {
                    console.error("Invalid response: designations should be an array");
                }
            } catch (err) {
                console.error("Error fetching designation:", err);
            }
        };

        if (effectRan.current === false) {
            fetchDesignation();
        }
        return () => {
            effectRan.current = true;
        };
    }, []);

    // Clear attendance data and fetch status when any dropdown changes
    useEffect(() => {
        setAttendanceData([]);
        // setOriginalData([]);
        setHasFetched(false);
    }, [state, district, month, year, project]); // ✅ Add project to depende

    const handleInputChange = (selectedOption, field) => {
        let value = selectedOption ? selectedOption.value : null;
        // Special handling for "All Districts"
        // Special handling for "All Districts"
        if (field === "district" && value === 0) {
            value = 0; // 0 = All districts (numeric, compatible with ID-based logic)
        }
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setProject(null); // ✅ Clear project when state changes
                break;
            case 'clients':
                setClients(value);
                setProject(null);
                break;
            case 'district':
                setDistrict(value);
                // setMonth(null);
                break;
            case 'month':
                setMonth(value);
                break;
            case 'project':
                setProject(value); // ✅ Handle project selection
                break;
            case 'designations':
                setSelectedDesignation(value);
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };
    const handleYearChange = (date) => {
        setYear(date ? date.getFullYear() : null);
        setErrors(prev => ({ ...prev, year: null }));
    };
    const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);

    useEffect(() => {
        const fetchEmployeeData = async () => {
            const roleId = localStorage.getItem("roleId");
            const employeeId = localStorage.getItem("employeeId");

            // ---- ADMIN (roleId === "1") ----
            if (roleId === "1") {
                if (!state) {
                    setEmployeeData([]);
                    return;
                }

                try {
                    const data = await fetchEmployeeDetails(state, district, selectedDesignation);
                    setEmployeeData(Array.isArray(data) ? data : []);
                } catch (error) {
                    console.error("Admin fetch error:", error);
                    setErrors((prev) => ({ ...prev, general: "Failed to fetch employees" }));
                    setEmployeeData([]);
                }
            }

            // ---- EMPLOYEE (roleId === "13") ----
            else if (roleId === "13") {
                if (!employeeId) {
                    setEmployeeData([]);
                    return;
                }

                try {
                    const data = await fetchEmployeeFromSelf(employeeId);
                    // API may return a single object → wrap in array for the table
                    setEmployeeData(Array.isArray(data) ? data : [data]);
                } catch (error) {
                    console.error("Employee fetch error:", error);
                    setErrors((prev) => ({ ...prev, general: "Failed to fetch employee" }));
                    setEmployeeData([]);
                }
            }
        };

        fetchEmployeeData();
    }, [state, district, selectedDesignation]);




    return (

        <div className="Data-employee-container">
            {/* {roleId === "1" && ( */}
            <div className="Data-employee-box">
                <h2 className="Data-employee-heading">Employees Details</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                {roleId === "1" && (
                    <form>
                        <div className="Data-employee-maincontainer">
                            <div className="Data-employee-container-part">
                                <div className={`Data-employee-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                    <Select
                                        name="state"
                                        options={stateOptions}
                                        value={stateOptions.find(opt => opt.value === state) || null}
                                        onChange={option => handleInputChange(option, 'state')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}

                                    />
                                    <label><span className="required">*</span>State</label>
                                    {errors.state && <div className="error-message">{errors.state}</div>}
                                </div>
                            </div>
                            <div className="Data-employee-container-part">
                                <div className="Data-employee-container-part">
                                    <div className={`Data-employee-floating-label-container ${isFocused.district || district !== null ? 'float-label' : ''}`}>
                                        <Select
                                            // ... (other Select props)
                                            name="district"
                                            options={districtOptions}
                                            // value comparison remains correct
                                            value={districtOptions.find(opt => opt.value === district) || null}
                                            onChange={option => handleInputChange(option, 'district')}
                                            onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                            onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                            placeholder=" "
                                            isClearable
                                            menuPortalTarget={document.body}
                                            styles={selectStyles}
                                        />
                                        <label>District</label>
                                        {errors.district && <div className="error-message">{errors.district}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="Data-employee-maincontainer">
                            <div className="Data-employee-container-part">
                                <div className={`Data-employee-floating-label-container ${isFocused.selectedDesignation || selectedDesignation ? 'float-label' : ''}`}>
                                    <Select
                                        options={designations}
                                        value={designations.find((option) => option.value === selectedDesignation) || null}
                                        onChange={(selectedOption) => handleInputChange(selectedOption, 'designations')}
                                        placeholder=""
                                        isClearable
                                        menuPortalTarget={document.body}
                                        // styles={{
                                        //     menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        //     control: (provided) => ({
                                        //         ...provided,
                                        //         backgroundColor: "#fff",
                                        //         borderColor: "#c9c9c9",
                                        //     }),
                                        //     singleValue: (provided) => ({ ...provided, color: "#474747" }),
                                        // }}
                                        styles={selectStyles}
                                    />
                                    <label>Designation</label>
                                    {/* {errors.jobPosition && <p className="error">{errors.jobPosition}</p>} */}
                                </div>
                            </div>
                            <div className="Data-employee-container-part">

                            </div>
                        </div>
                        {/* <div className="Data-employee-maincontainer">
                        <div className="Data-employee-container-part">
                            <div className={`Data-employee-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={year ? new Date(year, 0, 1) : null}
                                    onChange={handleYearChange}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    placeholderText=""
                                    className="Data-employee-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}

                                    title="Select a year"
                                />
                                <label><span className="required">*</span>Year</label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>
                        <div className="Data-employee-container-part">
                            <div className={`Data-employee-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                <Select
                                    name="month"
                                    options={monthOptions}
                                    value={monthOptions.find(opt => opt.value === month) || null}
                                    onChange={option => handleInputChange(option, 'month')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Month</label>
                                {errors.month && <div className="error-message">{errors.month}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="Data-employee-maincontainer">
                        <div className="epf-esic-updation-container-part">
                            <div className={`epf-esic-updation-floating-label-container ${isFocused.clients || clients ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={clientResponse}
                                    value={clientResponse.find(opt => opt.value === clients) || null}
                                    onChange={option => handleInputChange(option, 'clients')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, clients: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, clients: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Client</label>
                                {errors.project && <div className="error-message">{errors.project}</div>}
                            </div>

                        </div>
                        <div className="Data-employee-container-part">
                            <div className={`Data-employee-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={projectResponse}
                                    value={projectResponse.find(opt => opt.value === project) || null}
                                    onChange={option => handleInputChange(option, 'project')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>
                                    <span className="required">*</span>Project
                                </label>
                                {errors.project && <div className="error-message">{errors.project}</div>}
                            </div>
                        </div>

                    </div> */}
                    </form>
                )

                }
            </div>



            <div className="PFRegistration-report-btn-div">
                <button
                    type="button"
                    className="PFRegistration-report-btn"
                    onClick={generateExcel}
                    disabled={employeeData.length === 0}  // ✅ disabled if no data
                >
                    Download Excel
                </button>
                {/* <button
                        type="button"
                        className="PFRegistration-report-btn"
                        onClick={generatePDF}
                        disabled={attendanceData.length === 0}  // ✅ disabled if no data
                    >
                        Download PDF
                    </button> */}
            </div>

            {/* ✅ Table Section */}
            <div className="Data-table">

                <div className="Data-mid-table">
                    <table className="Data-report">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Employee Name</th>
                                <th>Designation</th>
                                <th>Working District</th>
                                <th>Date of Joining</th>
                                <th>Graduation ( specialization )</th>
                                <th>Post Graduation ( specialization )</th>
                            </tr>
                        </thead>
                        <tbody>
                            {employeeData.length > 0 ? (
                                employeeData.map((emp, index) => (
                                    <tr key={emp.id || index}>
                                        <td>{index + 1}</td>
                                        <td>{emp.fullName || '-'}</td>
                                        <td>{emp.designation || '-'}</td>
                                        <td>{emp.workingDistrict || '-'}</td>
                                        <td style={{ whiteSpace: "nowrap" }}>
                                            {new Date(emp.dateOfJoining)
                                                .toLocaleDateString("en-GB")
                                                .replace(/\//g, "-")}
                                        </td>



                                        <td>{emp.graduation === "N/A" ? "-" : emp.graduation || "-"}</td>
                                        <td>{emp.postGraduation === "N/A" ? "-" : emp.postGraduation || "-"}</td>

                                        {/* <td>
                      <Link
                        to={`/employeeview/${emp.employeeUniqueId}`} // ✅ Pass employeeUniqueId in the URL
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View
                      </Link>
                    </td> */}

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center' }}>
                                        {state ? 'No data found' : 'Please select a State to fetch employees'}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default EmployeesData;